module.exports = __webpack_public_path__ + "img/yangzhou-home-bg.31f6597.png";